import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['collapsible', 'label', 'chevron'];

  initialize () {
    this.collapsed = false
  }

  toggle () {
    this.collapsed = !this.collapsed

    if (this.collapsed) {
      this.labelTarget.innerHTML = 'Show'
      this.chevronTarget.style.transform = 'rotate(-90deg)'
    } else {
      this.labelTarget.innerHTML = 'Hide'
      this.chevronTarget.style.transform = 'rotate(90deg)'
    }

    this.collapsibleTarget.classList.toggle('hide')
    this.collapsibleTarget.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }
}
